// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.overflow-link[data-v-e2584c9e] {\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n.doctor-list[data-v-e2584c9e] {\n  list-style: disc;\n  margin: 0;\n  padding-left: 1.25rem;\n}\n", ""]);
// Exports
module.exports = exports;
